import { useTranslation } from 'react-i18next';
import enProjects from '../data/projects-en.json';
import jaProjects from '../data/projects-ja.json';

const useLocalizedProjects = () => {
  const { i18n } = useTranslation();
  return i18n.language === 'ja' ? jaProjects : enProjects;
};

export default useLocalizedProjects;
